import { render, staticRenderFns } from "./SelectWithCustom.vue?vue&type=template&id=3a2a363c&"
import script from "./SelectWithCustom.vue?vue&type=script&lang=ts&"
export * from "./SelectWithCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports